import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { ROUTES } from '../routes'
import NormalLayoutContainer from './shared/NormalLayoutContainer'
import { PageTitle } from '../components/page-title'
import { Spinner } from './shared/Spinner'
import TermsAndConditionAgreementList from '../components/terms-and-condition-agreement/TermsAndConditionAgreementList'
import { useSelector } from 'react-redux'
import termsAndConditionsQuery from '../graphql/queries/termsAndConditions'
import QUERY_KEYS from '../graphql/queryKeys'
import { captureErrorAndNotify } from '../utilities/errorHandlers'
import useQuery from '../hooks/useQuery'
import Switch from '../components/Switch'

export default function TermsAndConditionsPage () {
  const { user } = useSelector(({ user }) => ({ user: user.user }))
  const [showDisabled, setShowDisabled] = useState(false)
  const isEnabled = !showDisabled

  const { data: { termsAndConditions } = {}, isFetching, isError } = useQuery(
    [QUERY_KEYS.termsAndConditions, { haulerId: user.haulerId, isEnabled, forAssignment: false }],
    termsAndConditionsQuery,
    {
      onError (error) {
        captureErrorAndNotify(error, 'Failed to retrieve T&C agreements')
      },
      placeholderData: { termsAndConditions: [] }
    }
  )

  const agreements = termsAndConditions || []

  return (
    <NormalLayoutContainer>
      <div className='container-fluid'>
        <PageTitle title='Terms and Conditions Settings' className='dis-flex-page-title'>
          <div className='dis-flex-page-title'>
            <div className='dis-toggle-switch-wrapper dis-flex-page-title'>
              <Switch
                size='small'
                checked={showDisabled}
                onChange={setShowDisabled}
              />
              <div className='dis-toggle-label'>Show Disabled</div>
            </div>
            <Link className='dis-btn dis-btn-lg dis-btn-primary push-down-super-small' to={ROUTES.createTermsAndConditionAgreement}>
              New T&C Template
              <i className='material-icons pull-right thumbster-button-icon no-margin-bs-xs'>add_circle</i>
            </Link>
          </div>
        </PageTitle>

        {isFetching && <Spinner isFetching />}
        {!isFetching && isError && (
          <div className='row panel panel-default'>
            <h4 className='text-center'>Unable to load T&C agreements</h4>
          </div>
        )}
        {!isFetching && !isError && (
          <div className='row panel panel-default'>
            {agreements.length === 0 && <h4 className='text-center'>No T&C Agreements</h4>}
            {agreements.map(agreement => (
              <TermsAndConditionAgreementList
                key={agreement.id}
                agreement={agreement}
              />
            ))}
          </div>
        )}
      </div>
    </NormalLayoutContainer>
  )
}
